import GameOrderList from '../components/game-order/List'

export default [
  { name: 'GameOrderList', path: '/game-order/', component: GameOrderList, props: { pageTitle: 'Game Order List' } }
]
